"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_container_1 = __importDefault(require("./modal.container"));
const modal_style_1 = __importDefault(require("../modal.style"));
const typography_1 = require("components/atoms/typography");
const ModalLog = ({ appTheme = 'light', show, onClose, dataLog }) => {
    return ((0, jsx_runtime_1.jsx)(modal_container_1.default, Object.assign({ show: show, modalTitle: 'Logs', appTheme: appTheme, handleClose: onClose, modalSubtitle: dataLog.filename, style: modal_style_1.default.modalLogsContainer(appTheme) }, { children: (0, jsx_runtime_1.jsx)("div", { children: dataLog.log_message.length > 0 ? dataLog.log_message.split(',').map((item, idx) => ((0, jsx_runtime_1.jsxs)(typography_1.Typography, Object.assign({ typographyType: 'h3', style: {
                    marginTop: 0, lineHeight: '24px', fontSize: 16, fontWeight: 400, wordWrap: 'break-word',
                    marginBottom: idx === dataLog.log_message.split(',').length - 1 ? 0 : 12,
                    color: appTheme === 'light' ? '#404041' : '#FFFFFF'
                } }, { children: [item, ' ', (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { color: '#FF0000', fontWeight: 600 } }, { children: "!" }))] }), idx))) : null }) })));
};
exports.default = ModalLog;
